export const TilesClass = {
	root: 'gov-tiles',
}

export const TileClass = {
	root: 'gov-tile',
	icon: 'gov-tile__icon',
	arrow: 'gov-tile__arrow',
	title: 'gov-tile__title',
	link: 'gov-tile__link',
	content: 'gov-tile__content',
	heading: 'gov-tile__heading',
}
